import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import CategoryList from 'components/CategoryList';

import { withData } from 'lib';
import { SettingsCategoryListPageQuery } from '__generated__/SettingsCategoryListPageQuery.graphql';

const query = graphql`
  query SettingsCategoryListPageQuery {
    ...CategoryList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCategoryListPageQuery>;
};

const SettingsCategoryListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsCategoryListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Kategorijos' },
      ]}>
      <CategoryList data={data} />
    </Page>
  );
};

export default withData<SettingsCategoryListPageQuery>({
  query,
})(SettingsCategoryListPage);
